import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserStaffQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetCurrentUserStaffQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly companyReportDownloads?: ReadonlyArray<{ readonly __typename?: 'SupervisionCompanyReportDownloads', readonly connectedUser: { readonly __typename?: 'AccountsConnectedUser', readonly id: string, readonly uuid: string, readonly profile?: { readonly __typename?: 'AccountsProfile', readonly name?: string | null } | null }, readonly downloadMetrics?: ReadonlyArray<{ readonly __typename?: 'SupervisionCompanyDownloadMetrics', readonly downloads: number, readonly directClickCount: number, readonly pageOpenCount: number, readonly company: { readonly __typename?: 'AccountsCompany', readonly uuid: string, readonly id: string, readonly name: string } } | null> | null } | null> | null } | null };

export type GetCurrentUserSummaryQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetCurrentUserSummaryQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly companySensorMetrics?: ReadonlyArray<{ readonly __typename?: 'SupervisionCompanySensorMetrics', readonly company: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly uuid: string, readonly name: string }, readonly connectedUsers?: ReadonlyArray<{ readonly __typename?: 'AccountsConnectedUser', readonly uuid: string, readonly profile?: { readonly __typename?: 'AccountsProfile', readonly name?: string | null } | null } | null> | null, readonly sensors?: ReadonlyArray<{ readonly __typename?: 'SupervisionSensorMetrics', readonly name: string, readonly fixed: number, readonly found: number, readonly resolvedAvg: number, readonly resolvedMax: number, readonly resolvedMin: number, readonly hasExceptions: boolean, readonly isDisabled: boolean } | null> | null } | null> | null } | null };


export const GetCurrentUserStaffDocument = gql`
    query GetCurrentUserStaff($startDate: Date!, $endDate: Date!) {
  currentUser {
    companyReportDownloads(startDate: $startDate, endDate: $endDate) {
      connectedUser {
        id
        uuid
        profile {
          name
        }
      }
      downloadMetrics {
        company {
          uuid
          id
          name
        }
        downloads
        directClickCount
        pageOpenCount
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserStaffQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserStaffQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCurrentUserStaffQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserStaffQueryPage, GetCurrentUserStaffQueryVariables> & ({ variables: GetCurrentUserStaffQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserStaffQueryPage, GetCurrentUserStaffQueryVariables>(GetCurrentUserStaffDocument, options);
      }
export function useGetCurrentUserStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserStaffQueryPage, GetCurrentUserStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserStaffQueryPage, GetCurrentUserStaffQueryVariables>(GetCurrentUserStaffDocument, options);
        }
export function useGetCurrentUserStaffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserStaffQueryPage, GetCurrentUserStaffQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserStaffQueryPage, GetCurrentUserStaffQueryVariables>(GetCurrentUserStaffDocument, options);
        }
export type GetCurrentUserStaffQueryHookResult = ReturnType<typeof useGetCurrentUserStaffQuery>;
export type GetCurrentUserStaffLazyQueryHookResult = ReturnType<typeof useGetCurrentUserStaffLazyQuery>;
export type GetCurrentUserStaffSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserStaffSuspenseQuery>;
export type GetCurrentUserStaffQueryResult = Apollo.QueryResult<GetCurrentUserStaffQueryPage, GetCurrentUserStaffQueryVariables>;
export const GetCurrentUserSummaryDocument = gql`
    query GetCurrentUserSummary($startDate: Date!, $endDate: Date!) {
  currentUser {
    companySensorMetrics(startDate: $startDate, endDate: $endDate) {
      company {
        id
        uuid
        name
      }
      connectedUsers {
        uuid
        profile {
          name
        }
      }
      sensors {
        name
        fixed
        found
        resolvedAvg
        resolvedMax
        resolvedMin
        hasExceptions
        isDisabled
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserSummaryQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserSummaryQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCurrentUserSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserSummaryQueryPage, GetCurrentUserSummaryQueryVariables> & ({ variables: GetCurrentUserSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserSummaryQueryPage, GetCurrentUserSummaryQueryVariables>(GetCurrentUserSummaryDocument, options);
      }
export function useGetCurrentUserSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserSummaryQueryPage, GetCurrentUserSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserSummaryQueryPage, GetCurrentUserSummaryQueryVariables>(GetCurrentUserSummaryDocument, options);
        }
export function useGetCurrentUserSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserSummaryQueryPage, GetCurrentUserSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserSummaryQueryPage, GetCurrentUserSummaryQueryVariables>(GetCurrentUserSummaryDocument, options);
        }
export type GetCurrentUserSummaryQueryHookResult = ReturnType<typeof useGetCurrentUserSummaryQuery>;
export type GetCurrentUserSummaryLazyQueryHookResult = ReturnType<typeof useGetCurrentUserSummaryLazyQuery>;
export type GetCurrentUserSummarySuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSummarySuspenseQuery>;
export type GetCurrentUserSummaryQueryResult = Apollo.QueryResult<GetCurrentUserSummaryQueryPage, GetCurrentUserSummaryQueryVariables>;